export const CLASS_COLORS = [
    // Primary and Secondary Colors
    "#FF0000", // Red
    "#00FF00", // Green
    "#0000FF", // Blue
    "#FFFF00", // Yellow
    "#FF00FF", // Magenta
    "#00FFFF", // Cyan

    // Distinct Tertiary Colors
    "#FFA500", // Orange
    "#800080", // Purple
    "#008000", // Dark Green
    "#FF4500", // Orange Red
    "#4169E1", // Royal Blue
    "#32CD32", // Lime Green
    "#FF69B4", // Hot Pink
    "#4B0082", // Indigo
    "#FFD700", // Gold
    "#00CED1", // Dark Turquoise
    "#FF6347", // Tomato
    "#8B4513", // Saddle Brown
    "#2E8B57", // Sea Green
    "#BA55D3", // Medium Orchid
  ];














